import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import LineChartComponent from '../Components/LineChartComponent';
import BarChartComponent from './BarChartComponent';
import { colours } from '../helpers';

const SELECT_REASON_MESSAGE = 'No data. Select a Reason.';
const NO_DATA_MESSAGE = 'No data found for selected reason.';
const getPanelFooter = (selectedReason, chartData) => {
  if (!selectedReason) {
    return SELECT_REASON_MESSAGE;
  }
  else if (chartData.length === 0) {
    return NO_DATA_MESSAGE;
  }

  // show no footer
  return undefined;
};

class RegressionFailureTrendsComponent extends React.Component {
  static propTypes = {
    byTimeChartDataAndLabels: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      labels: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    byBuildChartDataAndLabels: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      labels: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    byNodeChartDataAndLabels: PropTypes.shape({
      data: PropTypes.arrayOf(PropTypes.number).isRequired,
      labels: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    selectedReason: PropTypes.string.isRequired
  };

  render() {
    const {
      byTimeChartDataAndLabels,
      byBuildChartDataAndLabels,
      byNodeChartDataAndLabels,
      selectedReason
    } = this.props;

    const byBuildSeries = byBuildChartDataAndLabels.data.map(() => {
      return { 'colour' : colours.colours.red };
    });
    const byNodeSeries = byNodeChartDataAndLabels.data.map(() => {
      return { 'colour' : colours.colours.red };
    });

    return (
      <div>
        <Row style={{ height: 1300, width: 1300, padding: 20 }}>
          <Col md={4}>
            <Col>
              <LineChartComponent
                series={[{
                  'label' : 'Failures Per Day',
                  'backgroundColor' : colours.colours.red,
                  'borderColor' : colours.colours.red
                }]}
                data={[byTimeChartDataAndLabels.data]}
                labels={byTimeChartDataAndLabels.labels}
                panelOptions={{
                  title: 'Trend By Time',
                  bsStyle: 'warning',
                  footer: getPanelFooter(selectedReason, byTimeChartDataAndLabels.data)
                }}
              />
            </Col>
          </Col>
          <Col md={4}>
            <Col>
              <BarChartComponent
                noLegend
                series={byBuildSeries}
                data={byBuildChartDataAndLabels.data}
                labels={byBuildChartDataAndLabels.labels}
                yMin={0}
                yMax={
                  Math.ceil((Math.max(...byBuildChartDataAndLabels.data) / 100)) * 100
                }
                panelOptions={{
                  title: 'Trend By Build',
                  bsStyle: 'warning',
                  footer: getPanelFooter(selectedReason, byBuildChartDataAndLabels.data)
                }}
              />
            </Col>
          </Col>
          <Col md={4}>
            <Col>
              <BarChartComponent
                noLegend
                series={byNodeSeries}
                data={byNodeChartDataAndLabels.data}
                labels={byNodeChartDataAndLabels.labels}
                yMin={0}
                yMax={
                  Math.ceil((Math.max(...byNodeChartDataAndLabels.data) / 100)) * 100
                }
                panelOptions={{
                  title: 'Trend By Node',
                  bsStyle: 'warning',
                  footer: getPanelFooter(selectedReason, byNodeChartDataAndLabels.data)
                }}
              />
            </Col>
          </Col>
        </Row>
      </div>
    );
  }
}

export default RegressionFailureTrendsComponent;

export const testingExports = {
  getPanelFooter,
  SELECT_REASON_MESSAGE,
  NO_DATA_MESSAGE
};


// WEBPACK FOOTER //
// src/Components/RegressionFailureTrendsComponent.jsx